export enum KanbanColumnWidth {
  Collapsed = 240,
  Expanded = 360
}
